<app-icon [mat-dialog-close] name="close" centered />
